import { render, staticRenderFns } from "./CarHistory.vue?vue&type=template&id=bd8d7aa4&scoped=true&"
import script from "./CarHistory.vue?vue&type=script&lang=js&"
export * from "./CarHistory.vue?vue&type=script&lang=js&"
import style0 from "./CarHistory.vue?vue&type=style&index=0&id=bd8d7aa4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8d7aa4",
  null
  
)

export default component.exports